var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcceptedStateActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#16A02C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2223 22.5C9.82505 22.5 9.48501 22.3586 9.20214 22.0757C8.91927 21.7928 8.77783 21.4528 8.77783 21.0556V10.9444C8.77783 10.5472 8.91927 10.2072 9.20214 9.92431C9.48501 9.64144 9.82505 9.5 10.2223 9.5H21.7778C22.1751 9.5 22.5151 9.64144 22.798 9.92431C23.0808 10.2072 23.2223 10.5472 23.2223 10.9444V21.0556C23.2223 21.4528 23.0808 21.7928 22.798 22.0757C22.5151 22.3586 22.1751 22.5 21.7778 22.5H10.2223ZM10.9445 19.6111H14.5556V18.1667H10.9445V19.6111ZM17.8417 18.1667L21.4167 14.5917L20.3876 13.5625L17.8417 16.1264L16.8126 15.0972L15.8014 16.1264L17.8417 18.1667ZM10.9445 16.7222H14.5556V15.2778H10.9445V16.7222ZM10.9445 13.8333H14.5556V12.3889H10.9445V13.8333Z",
    fill: "#FFF536"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptedStateActive);
export default __webpack_public_path__ + "static/media/accepted_state_active.2a051b131cf29c2ce3a93ab78090b299.svg";
export { ForwardRef as ReactComponent };